import React from 'react'
import { Modal, Select, Button } from 'antd'
import './style/enterprice-modal.less'

const { Option } = Select

const EnterprisesModal = props => (
  <div>
    <Modal
      title="选择企业"
      wrapClassName="login-enterprises-select"
      visible={props.visible}
      width="400px"
      style={{ top: '50%', height: 244, marginTop: -122 }}
      footer={
        (
          <Button
            type="primary"
            key="confirm"
            onClick={props.handleOk}
            disabled={!props.enterpriseId}
          >
            确定
          </Button>
        )
      }
    >
      <Select
        showSearch
        size="large"
        optionFilterProp="children"
        style={{ width: '224px', margin: '38px 20px 38px 60px' }}
        value={props.enterpriseId || undefined}
        placeholder="选择企业"
        onChange={props.handleEnterpriseChange}
      >
        {(props.enterprises || []).map(item => (
          <Option value={item.enterpriseId} key={item.enterpriseId}>{item.enterpriseName}</Option>
        ))}
      </Select>
    </Modal>
  </div>
)
export default EnterprisesModal
